import { queryOptions } from '@tanstack/react-query';

import { DashpivotApiService } from '@/services/dashpivot/dashpivot-api';

export const businessVerticalKeys = {
  all: ['workspace-settings', 'business-verticals'] as const,
};

export const businessRoleKeys = {
  all: ['workspace-settings', 'business-roles'] as const,
};

export const getBusinessVerticalsQueryOptions = () => {
  return queryOptions({
    queryKey: businessVerticalKeys.all,
    queryFn: async () => (await (await DashpivotApiService.getVerticals()).json()).map((vertical) => ({ ...vertical, name: vertical.description })),
  });
};

export const getBusinessRolesQueryOptions = () => {
  return queryOptions({
    queryKey: businessRoleKeys.all,
    queryFn: async () => await (await DashpivotApiService.getRoles()).json(),
  });
};
